/**
 * ScrollToElement
 */
export default class ScrollToElement {
  /**
   * constructor
   * @param {object} options - options
   */
  constructor(options = {}) {
    this.config = {
      selector: {
        anchor: '[data-scroll-to]',
      },
      dataSet: {
        scrollTo: 'scrollTo',
        scrollToDelay: 'scrollToDelay',
        scrollToMaxWidth: 'scrollToMaxWidth',
        scrollToBehaviour: 'scrollToMaxBehaviour',
      },
      ...options,
    };
    this.anchors = document.querySelectorAll(this.config.selector.anchor);
    if (!this.anchors.length) {
      return;
    }
    this.bindEvents();
  }

  /**
   * Delegate click events
   */
  bindEvents() {
    document.addEventListener('click', (event) => { this.scrollVertical(event); });
  }

  /**
   * Vertical scroll to target element.
   * The element can have optional parameter as data-attibutes:
   * - data-scroll-to-delay {number}:
   *   number in ms to delay the scroll: needed when the click-event also changes the page height.
   * - data-scroll-max-with {number}:
   *   fires event just if the max-width of the window matches.
   *   needed for responsive behaviour
   * - data-scroll-to-behaviour {object}:
   *   config-object for scrollIntoViewOptions.Notice: IE does not support the behaviour-option
   * @see https://developer.mozilla.org/de/docs/Web/API/Element/scrollIntoView
   * @param {MouseEvent} event - click
   */
  scrollVertical(event) {
    const element = event.target.closest(this.config.selector.anchor);
    if (element) {
      const defaultBehaviour = {
        block: 'start',
        behavior: 'smooth',
      };
      const target = document.querySelector(`.${element.dataset[this.config.dataSet.scrollTo]}`);
      const delay = target.dataset[this.config.dataSet.scrollToDelay] ?? 0;
      const behaviour = target.dataset[this.config.dataSet.scrollToBehaviour] ?? defaultBehaviour;
      const maxWidth = target.dataset[this.config.dataSet.scrollToMaxWidth] ?? 9999;
      const windowSize = window.matchMedia(`(max-width: ${maxWidth}px)`);
      if (windowSize.matches) {
        setTimeout(() => {
          target.scrollIntoView(behaviour);
        }, delay);
      }
    }
  }
}
